export default __webpack_public_path__ + "static/media/close.294eaa70.svg";